import { isFeatureEnabled } from '@lumapps/features/ducks/selectors';
import { isInstanceSuperAdmin } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

import { BEEKEEPER_INTEGRATION } from '../constants';

export const isBeekeeperIntegrationEnabled = isFeatureEnabled(BEEKEEPER_INTEGRATION);

export const isBeekeeperAdminAllowed = createSelector(
    isBeekeeperIntegrationEnabled,
    isInstanceSuperAdmin,
    (isEnabled, isAdmin) => {
        return isEnabled && isAdmin;
    },
);
